import { Breadcrumbs } from './Breadcrumbs';

class BreadcrumbsManager {

    static INSTANCE;

    _breadcrumbs = [Breadcrumbs.HOME];

    static getInstance() {
        return BreadcrumbsManager.INSTANCE
            ? BreadcrumbsManager.INSTANCE
            : new BreadcrumbsManager();
    }

    build(breadcrumbs) {
        this._breadcrumbs = [
            Breadcrumbs.HOME,
            ...breadcrumbs,
        ];
    }

    breadcrumbs() {
        return this._breadcrumbs;
    }

    existsBreadcrumb(breadcrumb) {
        return this._breadcrumbs.some((b) => b.id === breadcrumb.id);
    }

    removeBreadcrumb(breadcrumb) {
        this._breadcrumbs = this._breadcrumbs.filter((b) => b.id !== breadcrumb.id);
    }

    addBreadcrumb(breadcrumb) {
        if ( !this.existsBreadcrumb(breadcrumb) ) {
            this._breadcrumbs = [...this._breadcrumbs, breadcrumb];
        }
    }

    finishLoading(breadcrumb) {
        const index = this._breadcrumbIndex(breadcrumb.id);

        if ( index !== -1 ) {
            this._breadcrumbs[index] = {
                ...breadcrumb,
                loading: false,
            };
        }
    }

    _breadcrumbIndex(id) {
        return this
            ._breadcrumbs
            .findIndex((breadcrumb) => breadcrumb.id === id);
    }
}

export const BreadcrumbsManagerInstance = BreadcrumbsManager.getInstance();



// WEBPACK FOOTER //
// ./src/app/shared/breadcrumbs/BreadcrumbsManager.js